import React from 'react';  
import { createRoot } from 'react-dom/client';  
import ErrorBoundary from './ErrorBoundary';  
import App from './App';  
  
const container = document.getElementById('root');  
const root = createRoot(container);  
  
root.render(  
  <ErrorBoundary>  
    <App />  
  </ErrorBoundary>  
);  
